import React, { useCallback } from 'react'
import { EmblaOptionsType } from 'embla-carousel'  // https://www.embla-carousel.com/examples/predefined/
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import {
  /*NextButton,
  PrevButton,*/
  usePrevNextButtons
} from './embla_buttons' 
import keynotesData from '../../assets/Keynote/keynotes.json';
import { Section, Headshot, KeynoteTitle, Card, CardTitle, CardText, Embla, EmblaContainer, EmblaSlide, EmblaSlideNumber, EmblaViewport, /*EmblaControls, EmblaButtons,*/ CardSubTitle, CardColumn, BackgroundImage, KeynoteSubTitle } from './styles'
import andrew from '../../assets/Keynote/keynoteimages/andrew.png'
import sabrina from '../../assets/Keynote/keynoteimages/sabrina.png'
import patrick from '../../assets/Keynote/keynoteimages/patrick.png'
import karan from '../../assets/Keynote/keynoteimages/karan.png'
import grant from '../../assets/Keynote/keynoteimages/grant.png'
import tex from '../../assets/Keynote/keynoteimages/tex.png'
import ben from '../../assets/Keynote/keynoteimages/ben.png'
import greg from '../../assets/Keynote/keynoteimages/greg.png'
import les from '../../assets/Keynote/keynoteimages/les.png'
import jesse from '../../assets/Keynote/keynoteimages/jesse.png'
import anshul from '../../assets/Keynote/keynoteimages/anshul.png'

import background from '../../assets/FAQ/FAQ_BG.png';


type PropType = {
  slides: number[]
  options?: EmblaOptionsType
}

interface Slide {
  name: string;
  title: string;
  description: string;
}

const images = [andrew, sabrina, patrick, karan, grant, tex, ben, greg, les, jesse, anshul]

const Slides = keynotesData.map((card: Slide, index) => (
  <Card>
    <CardColumn>
      <CardTitle>
        {card.name}
      </CardTitle>
      <CardSubTitle>
        {card.title}
      </CardSubTitle>
      <CardText>
        {card.description}
      </CardText>
    </CardColumn>
    <CardColumn>
      <Headshot src={images[index]} alt={card.name}></Headshot>
    </CardColumn>
  </Card>
))

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay({ playOnInit: true, delay: 3000 })
  ])

  const {
    /*prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,*/
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  const onButtonAutoplayClick = useCallback(
    (callback: () => void) => {
      const autoplay = emblaApi?.plugins()?.autoplay
      if (!autoplay) return

      const resetOrStop =
        autoplay.options.stopOnInteraction === false
          ? autoplay.reset
          : autoplay.stop

      resetOrStop()
      callback()
    },
    [emblaApi]
  )

  return (
    <Embla onClick={() => onButtonAutoplayClick(onNextButtonClick)}>
      <EmblaViewport ref={emblaRef}>
        <EmblaContainer>
          {slides.map((index) => (
            <EmblaSlide key={index}>
              <EmblaSlideNumber>
                <span>{Slides[index]}</span>
              </EmblaSlideNumber>
            </EmblaSlide>
          ))}
        </EmblaContainer>
      </EmblaViewport>

      {/*<EmblaControls>
        <EmblaButtons>
          <PrevButton
            onClick={() => onButtonAutoplayClick(onPrevButtonClick)}
            disabled={prevBtnDisabled}
          />
          <NextButton
            onClick={() => onButtonAutoplayClick(onNextButtonClick)}
            disabled={nextBtnDisabled}
          />
        </EmblaButtons>
      </EmblaControls>*/}
    </Embla>
  )
}


  
const Keynote: React.FC = () => {
  const OPTIONS: EmblaOptionsType = { loop: true }
  const SLIDE_COUNT = 11
  const SLIDES = Array.from(Array(SLIDE_COUNT).keys())

  return (
    <Section>
      <BackgroundImage src={background} alt="clouds" />
      <KeynoteTitle>
        Opening Speakers
      </KeynoteTitle>
      <KeynoteSubTitle>
        Swipe or tap to see our opening speakers!
      </KeynoteSubTitle>
      <EmblaCarousel slides={SLIDES} options={OPTIONS}/>
    </Section>
    );
}
     
export default Keynote;